<template lang="html">
  <div class="container column full-height">
    <div class="game-cp container select-question">
      <div class="game-cp__question item flex-basis-700 flex-grow-1 container column select-question__left">
        <div class="select_question select_question-red container align-items-stretch">
          <div class="img container align-center">
            <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
          </div>
          <div class="flex-grow-1 bordered-box bordered-box-orange">
            <p>{{ question.question }}</p>
          </div>
        </div>

        <div class="game-cp__question__words container wrap justify-content-around">
          <span
            v-for="(a, key) in question.answers"
            :key="key"
            :draggable="!a.selected && !question.answered"
            :class="{
              disabled: a.selected,
              selected: selected == key
            }"
            @dragstart="dragstart($event, a)"
            @dragend="dragend"
            @touchstart="touch(a, key, $event)"
          >
              {{ a.word  }}
              <img class width="20" :src="require('@/assets/img/icons/check.svg')" v-if="('order' in a) && a.selected && (!textWords[a.position] ? false : (textWords[a.position].toLowerCase() == a.word.toLowerCase())) && question.answered">
          </span>
        </div>

        <div class="game-cp__question__info">
          <div class="container">
            <div class="game-cp__question__info__title">
              <p>Make the Sentence</p>
            </div>
            <!-- <div class="btn btn-rounded btn-square-box">
              <i class="fas fa-arrow-down"></i>
            </div> -->
          </div>
          <div
            class="btn btn-red btn-rounded btn-square-box"
            :class="{ 'to-touch': selected !== null }"
            @dragover="$event.preventDefault()"
            @drop="removeWord()"
            @touchstart="beforeRemoveWord($event)"
          >
            <i class="fas fa-trash-alt"></i>
          </div>
          <button class="game-cp__question__info__clear" type="button" name="button" :disabled="question.answered" @click="clearSentence()">
             <span>CLEAR</span>
             <div class="img-check">
              <img class width="20" :src="require('@/assets/img/icons/cancel.svg')">
             </div>
          </button>
          <button class="game-cp__question__info__check" type="button" name="button" :disabled="!filled" @click="answerQuestion()">
             <span>CHECK</span>
             <div class="img-check">
              <img class width="20" :src="require('@/assets/img/icons/check.svg')">
             </div>
          </button>
        </div>

        <div class="game-cp__question__sentence container justify-content-center wrap">
          <span
            v-for="(a, ind) in answers"
            :draggable="a.selected && !question.answered"
            :class="{ empty: !a.selected, selected: selectedWord == ind }"
            :key="ind"
            @dragenter="dragenter"
            @dragleave="dragleave"
            @dragover="$event.preventDefault()"
            @drop="drop(a)"
            @dragstart="dragstart($event, a)"
            @dragend="dragend"
            @touchstart="beforeTouch(a, ind, $event)"
          >
            {{ a.selected ? a.selected.word : `Word ${ind + 1}` }}

          </span>
        </div>
      </div>

      <div class="game-cp__answer item flex-basis-400 flex-grow-1 container column select-question__right">
        <div class="image animation-bottom game-image">
          <image-loader :src="question.img" />
        </div>
        <div class="game-cp__answer__result container align-items-center yours">
          <div class="game-cp__answer__result__title container align-items-center yours">
            Your Sentence
          </div>
          <div class="game-cp__answer__result__text container justify-content-start align-items-center">
            <img class="check" width="20" :src="require('@/assets/img/icons/check.svg')" v-if="question.hit">
            <span
              v-for="(a, ind) in answers"
              :class="{ wrong: (question.answered && (!a.selected || (a.selected.order == null) || (a.selected.word.toLowerCase() !== a.correct.word.toLowerCase()))) }"
              :key="ind"
            >
               <p class="margin-right-5"> {{ !a.selected ? '...' : a.selected.word }} </p>
            </span>
          </div>
        </div>
        <div class="game-cp__answer__result container align-items-center correct">
          <div class="game-cp__answer__result__title container align-items-center correct">
            Correct Sentence
          </div>
          <div class="game-cp__answer__result__text container justify-content-start align-items-center">
            {{ question.answered ? question.text : '...' }}
          </div>
        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">

        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>

        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="question.hit && question.answered">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta
          </span>
        </div>
        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="!question.hit && question.answered">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta
          </span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";

export default {
  name: "WriteWordGame",
  data() {
    return {
      question: {
        answers: []
      },
      toDrop: null,
      showFeedback: false,
      ended: false,
      finished: false,
      showInfo: false,
      index: 0,
      selected: null,
      selectedWord: null
    }
  },
  props: {
    topic: {
      type: Object,
      default: () => new Object()
    },
    subTopic: {
      type: Object,
      default: () => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    questions() {
      return this.subTopic.exercise.questions;
    },
    textWords() {
      return this.question.text
        ? this.question.text.toLowerCase().replace(/[^a-zA-Z0-9?\d\s:]/g, '').split(' ')
        : []
    },
    filled() {
      for (const a of this.answers) {
        if (!a.selected) return false;
      }
      return true;
    },
    answers () {
      let aswr_words = this.textWords.map((w, index) => ({ word: w, order: index })),
          words      = this.question.answers ? this.question.answers.filter(w => w.selected) : []

      aswr_words = aswr_words.map(w => ({ correct: w, selected: null}))

      for (const w of words) {
        this.$set(aswr_words[w.position], 'selected', w)
      }

      return aswr_words
    }
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    setCurrent() {
      let qst = {};
      for (const index in this.questions) {
        qst = this.questions[index];
        this.index = index;
        if (!this.questions[index].answered) {
          break;
        } else if (parseInt(index) === this.questions.length - 1) {
          this.ended = true;
          break;
        }
      }
      if (
        Object.keys(this.question).length == 0 ||
        qst._id !== this.question._id
      ) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers);
        this.$set(this, "question", qst);
        this.setWords();
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    setWords() {
      let words = this.question.answers.map(aswr => {
        this.$set(aswr, 'word', aswr.word.toLowerCase())
        return aswr
      })

      if (!this.question.shuffled) {
        const aswr_words = this.textWords.map((w, index) => ({ word: w, order: index, selected: false }))
        words = [ ...words, ...aswr_words ]
        this.$set(this.question, 'shuffled', true)
      }

      this.$set(this.question, 'answers', this.$shuffle(words).map((w, ind) => ({ ...w, a_index: ind })))
    },
    dragstart(event, word) {
      this.toDrop = word;

      event.dataTransfer.setData('application/json', word);
    },
    dragend() {
      this.toDrop = null;
    },
    dragenter() {
      this.canDrop = true;
    },
    dragleave() {
      this.canDrop = false;
    },
    drop(word) {
      if (this.canDrop && !this.question.answered) {
        let toDrop = this.toDrop

        event.dataTransfer.getData('application');

        if (typeof toDrop.selected === 'boolean') {
          if (word.selected) {
            this.$set(this.question.answers[word.selected.a_index], 'selected', false)
            this.$delete(this.question.answers[word.selected.a_index], 'position')
          }

          this.$set(this.question.answers[toDrop.a_index], 'selected', true)
          this.$set(this.question.answers[toDrop.a_index], 'position', word.correct.order)
          this.canDrop = false
        } else {
          if (word.correct.order !== toDrop.correct.order) {
            const index = toDrop.selected.a_index

            this.$set(this.question.answers[index], 'position', word.correct.order)

            if (word.selected) {
              this.$set(this.question.answers[word.selected.a_index], 'position', toDrop.correct.order)
            }
          }
        }
      }
    },
    touch (word, index, event) {
      event.preventDefault()

      if (!word.selected && !this.question.answered) {
        if (this.selected !== null && this.selected == index) {
          this.selected = null
          this.toDrop = null
        } else {
          this.toDrop = word;
          this.selected = index
        }
      }
    },
    beforeTouch (word, index, event) {
      event.preventDefault()

      if (!this.question.answered) {
        if (this.selected !== null) {
          this.touched(word)
        } else {
          if (this.selectedWord !== null) {
            if (this.selectedWord == index) {
              this.selectedWord = null
              this.toDrop = null
            } else {
              this.touched(word)
            }
          } else {
            if (word.selected) {
              this.toDrop = word
              this.selectedWord = index
            }
          }
        }
      }
    },
    touched (word) {
      let toDrop = this.toDrop

      if (toDrop) {
        if (typeof toDrop.selected === 'boolean') {
          if (word.selected) {
            this.$set(this.question.answers[word.selected.a_index], 'selected', false)
            this.$delete(this.question.answers[word.selected.a_index], 'position')
          }

          this.$set(this.question.answers[toDrop.a_index], 'selected', true)
          this.$set(this.question.answers[toDrop.a_index], 'position', word.correct.order)

          if (this.selected !== null) this.selected = null
        } else {
          if (word.correct.order !== toDrop.correct.order) {
            const index = toDrop.selected.a_index

            this.$set(this.question.answers[index], 'position', word.correct.order)

            if (word.selected) {
              this.$set(this.question.answers[word.selected.a_index], 'position', toDrop.correct.order)
            }
          }
          this.selectedWord = null
        }

        this.toDrop = null
      }
    },
    async answerQuestion() {
      if (!this.question.answered) {
        let correct = true

        for (const a of this.answers) {
          if (
            !a.selected ||
            a.selected.order == null ||
            a.selected.word.toLowerCase() !== a.correct.word.toLowerCase()
          ) {
            correct = false;
            break;
          }
        }

        this.$set(this.question, "answered", true);
        this.$set(this.question, "hit", correct);
        this.feedback();
        await this.save(this.question);
      }
    },
    clearSentence () {
      if (!this.question.answered) {
        for (const a of this.question.answers)
          this.$set(a, 'selected', false)
      }
    },
    removeWord() {
      if (this.toDrop && this.toDrop.selected) {
        this.$set(this.toDrop.selected, "selected", false);
      }
    },
    beforeRemoveWord (event) {
      event.preventDefault()

      if (this.selected !== null) {
        this.selected = null
        this.toDrop = null
      } else {
        if (this.selectedWord !== null) this.selectedWord = null
        this.removeWord()
      }
    },
    async feedback() {
      this.showFeedback = true;
      if (this.showFeedback) {
        await this.$delay(1500);
        this.showFeedback = false;
        gameBus.$emit("setEnabled", true);
      }
    },
    async save(question) {
      let scoreQuestions = 0,
          answered       = 0

      for (const qst of this.questions) {
        if (qst.answered) {
          if (qst.hit) scoreQuestions++
          answered++;
        }
      }

      const score = (scoreQuestions * 100) / this.questions.length;

      let payload = {
        points: score,
        finished: false,
        question: { ...question }
      }

      if (answered == this.questions.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500);
        this.showInfo = true;
      }

      gameBus.$emit("updateProgress", score);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    closeModal() {
      this.showInfo = false;
    },
    emitClose() {
      this.$refs["modal"].close();
    },
    async viewQuestion(index) {
      const question = this.questions[index];
      if (question && question.answered) {
        this.index = index;
        this.$set(this, "question", question);

        const wordIndex = question.answers.findIndex(x => x.selected);

        if (wordIndex > -1)
          this.selected = question.answers[wordIndex].word;
      }
    }
  },
  watch: {
    testMode(val) {
      this.setCurrent();
    },
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  mounted() {
    this.setCurrent();
    gameBus.$on("viewQuestion", this.viewQuestion);

    gameBus.$emit("updateProgress", this.subTopic.points);
    modalBus.$on("close", this.closeModal);
    gameBus.$on("setCurrent", this.setCurrent);
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion);

    modalBus.$off("close", this.closeModal);
    gameBus.$off("setCurrent", this.setCurrent);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";
@import "./src/assets/css/components/words";
</style>



// WEBPACK FOOTER //
// src/components/game/completePhrase.vue